import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { NoRecordFound } from "../../../../components/Common/NoRecordFound";
import { PlanDetailsModel } from "../../../../interfaces/plan.interface";
import { formatCurrency } from "../../../../config/currencies";


interface PlansTableProps {
  plans: PlanDetailsModel[];
  setPlanDetails: (plan: PlanDetailsModel) => void;
  setOpenDialog: (open: boolean) => void;
  setPlanId: any
}

const PlansTable: React.FC<PlansTableProps> = ({
  plans,
  setPlanDetails,
  setOpenDialog,
  setPlanId,
}) => {
  const TableHeader = (headers: string[]) => (
    <thead>
      <tr className="bg-gray-200">
        {headers.map((header, index) => (
          <th key={index} className="text-left py-2 px-4 border-b">
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );

  const renderPricing = (plan: PlanDetailsModel) => {
    if (plan.pricing && plan.pricing.length > 0) {
      return (
        <div className="space-y-1">
          {plan.pricing.map((price, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="text-sm font-medium">
                {formatCurrency(price.cost, price.currency)}
              </span>
              {price.isDefault && (
                <span className="px-1 py-0.5 text-xs bg-green-100 text-green-800 rounded">
                  Default
                </span>
              )}
            </div>
          ))}
        </div>
      );
    }
    
    // Fallback to legacy single currency display
    return plan.cost ? `$ ${parseFloat(plan.cost).toFixed(2)}` : "-";
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full border border-gray-300">
          {TableHeader([
            "Plan Id",
            "Plan",
            "Cost",
            "Charge Cycle",
            "Image Credits Per Book",
            "Story Creation Limit",
            "Book Pages",
            "",
          ])}
          <tbody>
            {plans && plans.length > 0 ? (
              plans.map((plan, index) => (
                <tr key={plan.id || index} className={index % 2 === 0 ? "bg-gray-100" : ""}>
                  <td className="text-left py-2 px-4 border-b">{plan.id}</td>
                  <td className="text-left py-2 px-4 border-b capitalize">{plan.name}</td>
                  <td className="text-left py-2 px-4 border-b">
                    {renderPricing(plan)}
                  </td>
                  <td className="text-left py-2 px-4 border-b capitalize">
                    {plan.chargeCycle || "-"}
                  </td>
                  <td className="text-left py-2 px-4 border-b">{plan.credits || "-"}</td>
                  <td className="text-left py-2 px-4 border-b">
                    {plan.storyCreationLimit || "Unlimited"}
                  </td>
                  <td className="text-left py-2 px-4 border-b">{plan.maxBookPage || "-"}</td>
                  <td className="text-left py-4 px-4 border-b flex gap-5">
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      className="cursor-pointer"
                      title="Edit Plan"
                      onClick={() => setPlanDetails(plan)}
                    />
                    <FontAwesomeIcon
                      icon={faTrashCan}
                      className="cursor-pointer"
                      title="Delete Plan"
                      onClick={() => {
                        setOpenDialog(true);
                        setPlanId(plan.id);
                      }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <NoRecordFound colSpan={8} />
            )}
        </tbody>
      </table>
    </div>
  );
};

export default PlansTable;
